import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type { UseTeamMemberListParams } from './types';

export const useDownloadTeamMemberListCsv: MutationFunction<
  string,
  void,
  [UseTeamMemberListParams]
> = (params, { requestOptions, queryOptions, query } = {}) => {
  const request = useRequest({
    ...requestOptions,
    headers: { ...requestOptions?.headers, Accept: 'text/csv' },
  });

  return useMutation({
    mutationFn: () =>
      request(`/suppliers/${params.locator}/members`, {
        init: {
          method: 'GET',
        },
        query,
      }),
    ...queryOptions,
    mutationKey: ['groups', 'teamMembers', 'downloadTeamMemberListCsv'],
  });
};
